import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import momentsImage from "@/assets/agent-user-detail/moments@3x.webp";

export const MomentsImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[momentsImage]}
      {...props}
    />
  );
};

MomentsImage.displayName = 'MomentsImage';
